<template>
    <Head title="Feed BB" />

    <AuthenticatedLayout>
        <Heading title="Feed BB" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"/>
        <div class="component-background-desktop min-h-[70vh]">
            <div class="flex flex-col justify-center items-center gap-y-12 px-4 pt-8 pb-10">
                <!-- <Carousel class="mt-8 max-w-[609px] !bg-none !p-0"/> -->
                <Post :amountLike="post.amountLike" :amountComment="post.amountComment" :comments="comments" :showComments="true" :postId="post.id" :midia="post.midia" :liked="post.liked" :key="key" :perfilPhoto="post.postProfile.avatar" :author="post.postProfile.name" :createdDate="post.createdAt" :text="post.text" :url="post.midia"/>
            </div>
            <!-- <div class="flex flex-col justify-center items-center gap-y-12 px-4">
                <Post v-for="(post, key) in postsMock" :key="key" :perfilPhoto="post.perfilPhoto" :author="post.author" :createdDate="post.createdDate" :text="post.text" :url="post.url" :link="post.link" class="max-w-[609px]" />
            </div> -->
            <!-- <div class="flex justify-center">
                <div class="flex px-4 mt-10 mb-14 gap-x-5">
                    <div class="text-primary flex flex-col justify-center items-center cursor-pointer text-xl" :class="select ? 'text-yellow' : 'text-white bg-primary' ">
                        <p>Ver mais</p>
                        <div>
                            <svg id="Chevron_-_Médio_-_Ícone" data-name="Chevron - Médio - Ícone" xmlns="http://www.w3.org/2000/svg" width="13.182" height="8" viewBox="0 0 13.182 8">
                                <g id="Chevron" transform="translate(13.182 0) rotate(90)">
                                    <path id="Caminho_10434" data-name="Caminho 10434" d="M7.788,7.1,1.921,12.97a.724.724,0,0,1-1.025,0l-.684-.684a.724.724,0,0,1,0-1.023l4.65-4.671L.211,1.92A.724.724,0,0,1,.212.9L.9.212a.724.724,0,0,1,1.025,0L7.788,6.079A.725.725,0,0,1,7.788,7.1Z" transform="translate(0 0)" fill="#ffe97d"/>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </AuthenticatedLayout>
</template>
<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';
import { Head } from "@inertiajs/inertia-vue3";
import Post from "@/Components/Post.vue"
import Carousel from "@/Components/UI/Dashboard/Carousel.vue";

export default {
    components: {
        AuthenticatedLayout,
        Heading,
        Head,
        Post,
        Carousel
    },
    props: {
        post: Object,
        comments: Object
    },
    data() {
        return {
            select: true,
        }
    }
}
</script>
